export default {
  Medico: 1,
  Parceiro: 2
}

export const TIPO_CONTA = { CORRENTE: 'checking', POUPANCA: 'savings' }
